import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=61d4d952&scoped=true&"
import script from "./svg-icon.vue?vue&type=script&lang=js&"
export * from "./svg-icon.vue?vue&type=script&lang=js&"
import style0 from "./svg-icon.vue?vue&type=style&index=0&id=61d4d952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d4d952",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d4d952')) {
      api.createRecord('61d4d952', component.options)
    } else {
      api.reload('61d4d952', component.options)
    }
    module.hot.accept("./svg-icon.vue?vue&type=template&id=61d4d952&scoped=true&", function () {
      api.rerender('61d4d952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/svg-icon.vue"
export default component.exports